import { getMemberPoints } from './getMemberPoints';
import { getOffers } from './getOffers';
import { getPointsHistory } from './getPointsHistory';

export async function getAllLoyaltyData() {
    const [memberPoints, offers, pointsHistory] = await Promise.all([
        getMemberPoints(),
        getOffers(),
        getPointsHistory(),
    ]);

    return {
        memberPoints,
        offers,
        pointsHistory,
    };
}
